<template lang="pug">
  tr
    th.text-truncate(
      v-for="header in headers.headers"
      v-show="isVisible(header)"
      :key="header.value"
      @click="setSortBy(header)"
      :class="listHeadersClasses(header)"
    )
      v-tooltip(bottom max-width="210px")
        span(slot="activator") {{ header.text }}
        span {{ header.tooltip }}
      v-icon(v-show='header.sortable === true') {{ sortIcon() }}
</template>

<script>
import { TEAM_MEMBER, ASC, DESC } from '@/Reporting/config/constants';
export default {
  props: {
    headers: {
      type: Object,
    },
    currentSortDir: {
      type: String,
    },
    sortField: {
      type: String,
    },
    sortOrder: {
      type: Number,
    },
    pageLimit: {
      type: Number,
    },
  },
  methods: {
    sortIcon() {
      if (this.currentSortDir === ASC) return 'arrow_upward';
      return 'arrow_downward';
    },
    setSortBy(header) {
      if (header.sortable) {
        this.$emit('click:sort', header.value);
      }
    },
    isVisible(header) {
      return header.visible;
    },
    listHeadersClasses(header) {
      return [
        'column',
        header.sortable ? 'sortable' : '',
        header.pinned ? 'pinned' : '',
        this.sortOrder === -1 ? DESC : ASC,
        header.value === this.sortField ? 'active' : '',
        header.value === TEAM_MEMBER ? 'text-xs-left' : 'text-xs-middle',
      ];
    },
  },
};
</script>

<style scoped lang="scss">
table.v-table > thead {
  display: table; /* to take the same width as tr */
  width: calc(100% - 17px);
}
th.pinned:nth-of-type(2) {
  left: 250px !important;
  z-index: 5 !important;
  position: sticky;
}
th.pinned:nth-of-type(3),
th.pinned:nth-of-type(4) {
  z-index: 4 !important;
  position: sticky;
}
</style>
